var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.384 136.638C158.384 137.684 156.322 138.605 154.209 139.397C147.482 141.914 140.357 143.196 133.175 143.182C105.45 143.182 81.2994 124.111 81.2994 99.6381C81.3349 96.3557 82.2458 93.1422 83.938 90.3294C85.6302 87.5166 88.0424 85.2064 90.9257 83.6372C65.8492 84.6918 59.4043 110.823 59.4043 126.133C59.4043 169.419 99.2982 173.807 107.893 173.807C112.528 173.807 119.518 172.46 123.713 171.136L124.48 170.878C140.623 165.297 154.385 154.387 163.501 139.942C163.78 139.502 163.905 138.982 163.855 138.463C163.806 137.945 163.585 137.457 163.227 137.078C162.87 136.699 162.396 136.45 161.881 136.37C161.366 136.291 160.84 136.385 160.384 136.638Z",
    fill: "url(#paint0_linear_604_1227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M160.384 136.638C158.384 137.684 156.322 138.605 154.209 139.397C147.482 141.914 140.357 143.196 133.175 143.182C105.45 143.182 81.2994 124.111 81.2994 99.6381C81.3349 96.3557 82.2458 93.1422 83.938 90.3294C85.6302 87.5166 88.0424 85.2064 90.9257 83.6372C65.8492 84.6918 59.4043 110.823 59.4043 126.133C59.4043 169.419 99.2982 173.807 107.893 173.807C112.528 173.807 119.518 172.46 123.713 171.136L124.48 170.878C140.623 165.297 154.385 154.387 163.501 139.942C163.78 139.502 163.905 138.982 163.855 138.463C163.806 137.945 163.585 137.457 163.227 137.078C162.87 136.699 162.396 136.45 161.881 136.37C161.366 136.291 160.84 136.385 160.384 136.638Z",
    fill: "url(#paint1_radial_604_1227)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9474 166.448C81.7216 163.205 77.1927 158.955 73.6241 153.945C69.5567 148.373 66.7577 141.978 65.4235 135.209C64.0894 128.44 64.2523 121.461 65.9009 114.762C67.5494 108.063 70.6437 101.805 74.9667 96.4283C79.2897 91.0516 84.7368 86.6858 90.9257 83.6371C92.7537 82.7758 95.8766 81.2173 100.031 81.2935C102.957 81.3148 105.839 82.0135 108.451 83.335C111.062 84.6564 113.332 86.5647 115.082 88.9102C117.448 92.0693 118.753 95.8966 118.809 99.8431C118.809 99.7201 133.14 53.2053 71.9367 53.2053C46.2156 53.2053 25.0646 77.614 25.0646 99.0287C24.9631 110.357 27.3869 121.565 32.1598 131.839C39.9601 148.482 53.6006 161.681 70.4912 168.93C87.3817 176.178 106.346 176.972 123.783 171.159C117.678 173.084 111.227 173.662 104.877 172.853C98.5269 172.043 92.4277 169.866 87.0002 166.472L86.9474 166.448Z",
    fill: "url(#paint2_linear_604_1227)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M86.9474 166.448C81.7216 163.205 77.1927 158.955 73.6241 153.945C69.5567 148.373 66.7577 141.978 65.4235 135.209C64.0894 128.44 64.2523 121.461 65.9009 114.762C67.5494 108.063 70.6437 101.805 74.9667 96.4283C79.2897 91.0516 84.7368 86.6858 90.9257 83.6371C92.7537 82.7758 95.8766 81.2173 100.031 81.2935C102.957 81.3148 105.839 82.0135 108.451 83.335C111.062 84.6564 113.332 86.5647 115.082 88.9102C117.448 92.0693 118.753 95.8966 118.809 99.8431C118.809 99.7201 133.14 53.2053 71.9367 53.2053C46.2156 53.2053 25.0646 77.614 25.0646 99.0287C24.9631 110.357 27.3869 121.565 32.1598 131.839C39.9601 148.482 53.6006 161.681 70.4912 168.93C87.3817 176.178 106.346 176.972 123.783 171.159C117.678 173.084 111.227 173.662 104.877 172.853C98.5269 172.043 92.4277 169.866 87.0002 166.472L86.9474 166.448Z",
    fill: "url(#paint3_radial_604_1227)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.25 112.217C113.776 112.832 112.317 113.682 112.317 115.533C112.317 117.063 113.313 118.533 115.082 119.769C123.508 125.628 139.391 124.855 139.432 124.855C145.675 124.84 151.8 123.151 157.168 119.963C162.582 116.801 167.077 112.278 170.204 106.844C173.332 101.409 174.984 95.2507 174.996 88.9803C175.149 75.8503 170.309 67.1204 168.352 63.2534C155.937 38.9679 129.138 25 99.9953 25C80.2867 24.9981 61.3694 32.7544 47.335 46.5914C33.3006 60.4285 25.2772 79.234 25 98.9406C25.2812 77.5318 46.5612 60.2419 71.8721 60.2419C73.9227 60.2419 85.6173 60.4411 96.4799 66.1419C106.054 71.169 111.069 77.2389 114.555 83.2561C118.176 89.5077 118.82 97.4056 118.82 100.552C118.82 103.698 117.215 108.362 114.25 112.217Z",
    fill: "url(#paint4_radial_604_1227)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.25 112.217C113.776 112.832 112.317 113.682 112.317 115.533C112.317 117.063 113.313 118.533 115.082 119.769C123.508 125.628 139.391 124.855 139.432 124.855C145.675 124.84 151.8 123.151 157.168 119.963C162.582 116.801 167.077 112.278 170.204 106.844C173.332 101.409 174.984 95.2507 174.996 88.9803C175.149 75.8503 170.309 67.1204 168.352 63.2534C155.937 38.9679 129.138 25 99.9953 25C80.2867 24.9981 61.3694 32.7544 47.335 46.5914C33.3006 60.4285 25.2772 79.234 25 98.9406C25.2812 77.5318 46.5612 60.2419 71.8721 60.2419C73.9227 60.2419 85.6173 60.4411 96.4799 66.1419C106.054 71.169 111.069 77.2389 114.555 83.2561C118.176 89.5077 118.82 97.4056 118.82 100.552C118.82 103.698 117.215 108.362 114.25 112.217Z",
    fill: "url(#paint5_radial_604_1227)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_1227",
    x1: 59.4043,
    y1: 128.734,
    x2: 163.894,
    y2: 128.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_604_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.115 129.557) scale(55.8832 53.089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_1227",
    x1: 114.491,
    y1: 83.4086,
    x2: 49.227,
    y2: 154.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_604_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3615 141.599) rotate(-81.3844) scale(84.0336 67.8906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_604_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1529 52.7581) rotate(92.2906) scale(118.699 252.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_604_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.659 70.3523) rotate(73.7398) scale(57.0316 46.3781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.5df39c19fb917b89d935bcdd9e9c293f.svg";
export { ForwardRef as ReactComponent };